import { request } from '../service';
export function getSummaryList(data) {
  return request({
    url: "/api/summary_score/get",
    method: "get",
    params: data
  });
}
export function startSummary(data) {
  return request({
    url: "/api/summary_score/start",
    method: "post",
    data: data
  });
}
export function endSummary(data) {
  return request({
    url: "/api/summary_score/end",
    method: "post",
    data: data
  });
}